import { render, staticRenderFns } from "./Observacoes.vue?vue&type=template&id=4407c77e&scoped=true&"
import script from "./Observacoes.vue?vue&type=script&lang=js&"
export * from "./Observacoes.vue?vue&type=script&lang=js&"
import style0 from "./Observacoes.vue?vue&type=style&index=0&id=4407c77e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4407c77e",
  null
  
)

export default component.exports